import script from "./NotificationsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationsView.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__